var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7 0c.483 0 .875.392.875.875v5.25h5.25a.875.875 0 0 1 0 1.75H7.874l.001 5.25a.875.875 0 0 1-1.75 0l-.001-5.25H.875a.875.875 0 0 1 0-1.75h5.25V.875C6.125.392 6.517 0 7 0z"
  })));
};

export default SvgPlus;